// Constants
import { TOKEN } from '@/app/constants/constants.js';

const lmdcUser = {
	state: {
		userToken: null,
		userAuthenticated: false,
		authExpiry: null,
		pinCode: null,
		userDetails: {
			id: null,
			customerId: null,
			emailAddress: null,
			firstName: null,
			lastName: null,
			status: null,
			userRole: null
		}
	},
	mutations: {
		setUserToken(state, userToken) {
			state.userToken = userToken;
		},
		setUserAuthentication(state, isAuthenticated) {
			state.userAuthenticated = isAuthenticated;
		},
		setPinCode(state, pinCode) {
			state.pinCode = pinCode;
		},
		setAuthExpiry(state, expiryDate) {
			state.authExpiry = expiryDate;
		},
		setUserDetails(state, userDetails) {
			state.userDetails = {...userDetails};
		},
		clearLmdcUserDetails(state) {
			state.userDetails = {};
		},
		clearUserToken(state) {
			state.userToken = null;
		},
		clearUserAuthentication(state) {
			state.userAuthenticated = false;
		},
		clearAuthExpiry(state) {
			state.authExpiry = null
		}
	},
	actions: {
		logout({commit}) {
			// remove user details when JWT expires.
			commit('clearLmdcUserDetails');
			commit('clearUserToken');
			window.location.href = '/login'
		},
		initializeLogoutTimer({dispatch}) {
			// kills the running instance of set timeout if the user logs in again.
			let logoutTimer = setTimeout(() => {
				dispatch('logout');
			}, TOKEN.EXPIRY);

			clearTimeout(logoutTimer);
		},
		unauthenticate({commit}) {
			commit('clearUserAuthentication');
			commit('clearAuthExpiry');
		},
		initializeUnauthenticateTimer({dispatch}) {
			// kills the running instance of set authenticate
			let unauthenticateTimer = setTimeout(() => {
				dispatch('unauthenticate');
			}, TOKEN.EXPIRY);
			
			clearTimeout(unauthenticateTimer);
		}
	},
	getters: {
		getUserToken(state) {
			return state.userToken;
		},
		getUserDetails(state) {
			return state.userDetails;
		},
		getUserAuthentication(state) {
			return state.userAuthenticated;
		},
		getAuthExpiry(state) {
			return state.authExpiry;
		},
		getPinCode(state) {
			return state.pinCode;
		}
	}
};

export default lmdcUser;
